import React, { useEffect, useMemo, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { toast } from "react-toastify";

import cartIcon from "../assets/images/cart.png";
import emptyCartIcon from "../assets/images/empty-cart.png";

import { toggleCartAction } from "../redux/actions/uiActions";
import { getCartItems, deleteCart, modifyCart, updateCart } from "../redux/actions/cartActions";
import { isAuthenticated } from "../auth";
import { checkCartProceed } from "../services/HomePageService";

import { REACT_APP_IMAGE_BASE_PATH } from "../helpers/config";
import { trimString } from "../helpers/helperFunctions";
import CartDrawer from "./CartDrawer";

const CartToggleComponent = () => {
  const dispatch = useDispatch();

  const myCartData = useSelector((state) => state.cartReducer.result || {});
  const cartItems = myCartData.cartItems || [];

  const cartCount = useMemo(() => cartItems.length, [cartItems]);

  useEffect(() => {
    dispatch(getCartItems());
  }, [dispatch]);

  const handleCartToggle = useCallback((e) => {
    e.preventDefault();
    dispatch(toggleCartAction());
  }, [dispatch]);

  return (
    <>
      <div className="header_cart order-1 mob-d-deactive">
        <Link
          to="#"
          className="cart__btn hover-btn pull-bs-canvas-left"
          title="Cart"
          onClick={handleCartToggle}
        >
          <img src={cartIcon} alt="cart" />
          <span className="noti_count2">{cartCount}</span>
        </Link>
      </div>

      <Link
        to="#"
        className="mob-d-active navitem"
        title="Cart"
        onClick={handleCartToggle}
        data-clr="#e4ecfa"
      >
        <div className="indicator" />
        <div className="hoverindicator" />
        <i className="f7--cart-fill" />
        <span className="noti_count2">{cartCount}</span>
      </Link>

      <CartDrawer
        handleCartToggle={handleCartToggle}
        cartCount={cartCount}
        data={myCartData}
      />
    
    </>
  );
};

export default CartToggleComponent;
